export default __webpack_public_path__ + "static/media/bm.ed0c88a2.svg";